import React, { useReducer, createContext, } from 'react';

export const NocItemContext = createContext('');

const initialState = {
    stationList: [],
    anthemProfiles: [], 
    profiles: [],
    counter: 0,
    totalStations: 0,
    loading: false, 
    error: null,
};

const reducer = (state, action) => {
    switch(action.type) {
        case 'SET_STATION_LIST': 
            return {
                ...state, 
                stationList: action.payload,
            };
        case 'SET_ANTHEM_PROFILES': 
            return {
                ...state, 
                anthemProfiles: action.payload,
            };
        case 'SET_RESPONSE_COUNTER': 
            return {
                ...state, 
                counter: action.payload,
            };
        case 'SET_TOTAL_STATIONS_COUNT':
            return {
                ...state, 
                totalStations: action.payload
            }
        case 'SET_PROFILES':
            return {
                ...state, 
                profiles: action.payload,
            }
        case 'INCREMENT_TOTAL_STATIONS_COUNT':
            return {
                ...state, 
                totalStations: state.totalStations + 1,
            }
        case 'DECREASE_TOTAL_STATIONS_COUNT':
            return {
                ...state, 
                totalStations: state.totalStations - 1,
            }
        case 'ADD_STATION':
            return {
                ...state,
                stationList: [...state.stationList, action.payload],
                totalStations: state.totalStations + 1,
            }
        case 'DELETE_STATION':
            return {
                ...state, 
                stationList: state.stationList.filter(station => station.id !== action.payload),
                totalStations: state.totalStations - 1,
            }
        case 'UPDATE_STATION':
            return {
                ...state, 
                stationList: state.stationList.map(station => (station.id === action.payload?.id) ? action.payload : station )
            }
        case 'START': 
            return {
                ...state, 
                loading: true
            };
        case 'LOADED':
            return {
                ...state, 
                loading: false,
            }

        default: 
            throw new Error();
    }
};

export const NocItemContextProvider = props => {
    
    const [state, dispatch] = useReducer(reducer, initialState);

    return(
        <NocItemContext.Provider value={[state, dispatch]}>
            {props.children}
        </NocItemContext.Provider>
    )
}
